import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const StyledTooltip = styled.span`
  position: relative;

  [role='button'] {
    cursor: help;
    border-bottom: 1px dashed ${themeGet('color.colorBlue')};
  }

  [role='tooltip'] {
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, calc(-100% - 10px));
    display: flex;
    justify-content: center;
    width: 300px;
    opacity: 0;
    transition: visibility 0s linear 0.2s, opacity 0.2s linear;
    pointer-events: none;
  }

  &:hover,
  &:focus {
    [role='tooltip'] {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.2s linear;
    }
  }

  [role='tooltip']::after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 8px 0 8px;
    border-color: ${themeGet('color.colorGrayBlue100')} transparent transparent
      transparent;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
  }

  [role='tooltip'] > div {
    max-width: 300px;
    background: ${themeGet('color.colorGrayBlue100')};
    color: ${themeGet('color.colorWhite')};
    padding: ${themeGet('scale.scaleUp01')};
    border-radius: ${themeGet('border.borderRadius')};
  }
`;

export default StyledTooltip;
